import React from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';
import { useStyles } from './styles';
import NextLink from 'next/link';
import getRedirectUrlAfterLogin from 'utils/getRedirectUrlAfterLogin';

export default function InfodesignJapan() {
  const classes = useStyles();

  return (
    <Box px={6} py={6} bgcolor="#FAFAFA">
      <Grid item xs={12}>
        <Typography variant="h2" className={classes.title}>
          あなたの作品が数分で完成！
        </Typography>

        <Box textAlign="center">
          <Typography>
            研究をシンプルにするために、 Mind the
            Graphは生まれました。このプラットフォームは使いやすく <br />
            初心者からプロ、個人からグループ、小規模なラボから大規模な組織まで <br />{' '}
            誰でも科学イラスト用の優れたイン フォグラフィックを作成できるようデザインされています。
          </Typography>
        </Box>
      </Grid>

      <Grid className={classes.itemContainer} container={true} spacing={8} alignItems="center">
        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img
              src="/images/drag-drop-icon.webp"
              loading="lazy"
              height="75"
              width="69.16"
              alt="mind-the-graph-ドラッグアンドドロップ"
            />
            <Typography component="h2">ドラッグアンドドロップ</Typography>
            <Typography className={classes.subTextContent}>
              イラスト、テキスト、テンプレー <br /> トを簡単に選択して管理
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img
              src="/images/premade-icon.webp"
              loading="lazy"
              height="75"
              width="76.66"
              alt="mind-the-graph-そのまま使える素材"
            />
            <Typography component="h2">そのまま使える素材</Typography>
            <Typography className={classes.subTextContent}>
              時間を無駄にしないでください テンプレ <br /> ートを使用して 色やテキストなどをカスタマ
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img
              src="/images/slides-icon.webp"
              loading="lazy"
              height="75"
              width="75"
              alt=" mind-the-graph-スライド-プレゼンテーション"
            />
            <Typography component="h2">スライド・プレゼンテーション</Typography>
            <Typography className={classes.subTextContent}>
              情報と科学のイラストを美しく <br /> インパクトのあるスライドに統合
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img
              src="/images/multiple-sizing-options-icon.webp"
              loading="lazy"
              height="75"
              width="73.27"
              alt="mind-the-graph-サイエンスイラスト-サイズ"
            />
            <Typography component="h2">複数のサイズ・オプション</Typography>
            <Typography className={classes.subTextContent}>
              般的な利用サイズをカバ <br /> ーしたすぐに使えるテンプレート
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img
              src="/images/ondemand-icon.webp"
              loading="lazy"
              height="75"
              width="61.42"
              alt=" mind-the-graph-オンデマンド-サイエンスイラスト"
            />
            <Typography component="h2">オンデマンドの科学イラスト</Typography>
            <Typography className={classes.subTextContent}>
              必要なものが正確に見つからない場合は、
              <br /> あなたのために新しいイラストをデザインします！
            </Typography>
          </Box>
        </Grid>

        <Grid item={true} xs={12} sm={6} lg={4}>
          <Box className={classes.item}>
            <img
              src="/images/online-platform-icon.webp"
              loading="lazy"
              height="75"
              width="76.75"
              alt="mind-the-graph-オンラインプラットフォーム"
            />
            <Typography component="h2">オンラインプラットフォーム</Typography>
            <Typography className={classes.subTextContent}>
              いつでもどこからでも作品にアクセス
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="center">
        <NextLink href={getRedirectUrlAfterLogin()} passHref={true}>
          <Button className={classes.button} color="primary" variant="contained">
            今すぐ作成する
          </Button>
        </NextLink>
      </Box>
    </Box>
  );
}
